export default __webpack_public_path__ + "static/media/portraits.da23c785.jpg";